<template>
	<div class="disclaimer-container">
		<!-- 面包屑导航区域 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><span>系统管理</span></el-breadcrumb-item>
			<el-breadcrumb-item>免责声明管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
				<el-form ref="queryForm" :model="queryParams" label-width="70px" inline size="small">
					<!-- 只有超级管理员才显示运营商下拉框 -->
					<el-form-item label="运营商:" v-if="isAdmin">
						<el-select v-model="queryParams.distributorId" placeholder="请选择" clearable style="width: 150px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标题:">
						<el-input :clearable="true" v-model="queryParams.title" placeholder="请输入标题"
							style="width: 200px;" />
					</el-form-item>
					<el-form-item label="状态:">
						<el-select v-model="queryParams.enabled" placeholder="请选择" clearable style="width: 120px;">
							<el-option label="开启" :value="1"></el-option>
							<el-option label="关闭" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="handleQuery()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="handleAdd()">+ 添加免责声明</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 表格和分页区域 -->
			<div class="table-container">
				<!-- 列表区域 -->
				<el-table :data="dataList" border stripe :header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }">
					<el-table-column type="index" width="60"></el-table-column>
					<el-table-column label="标题" prop="title" show-overflow-tooltip></el-table-column>
					<!-- 只有超级管理员才显示运营商列 -->
					<el-table-column label="运营商" prop="distributorName" width="200" v-if="isAdmin">
						<template slot-scope="scope">
							{{ scope.row.distributorName || '全局' }}
						</template>
					</el-table-column>
					<el-table-column label="版本号" prop="version" width="100"></el-table-column>
					<el-table-column label="状态" prop="enabled" width="100">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.enabled" :active-value="1" :inactive-value="0"
								@change="handleStatusChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="createTime" width="180"></el-table-column>
					<el-table-column label="更新时间" prop="updateTime" width="180"></el-table-column>
					<el-table-column fixed="right" header-align="center" align="center" width="200" label="操作">
						<template slot-scope="scope">
							<el-button size="mini" style="background-color: #3CA757;color: #FFFFFF;" icon="el-icon-edit"
								@click="handleEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" icon="el-icon-delete"
								@click="handleDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页区域 -->
				<div class="pagination-container">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]"
						:page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>

			<!-- 添加/编辑弹框 -->
			<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
				<el-form :model="form" :rules="rules" ref="formRef" label-width="100px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<el-form-item label="标题:" prop="title">
								<el-input v-model.trim="form.title" placeholder="请输入标题"></el-input>
							</el-form-item>
						</el-col>
						<!-- 只有超级管理员才显示运营商选择 -->
						<el-col :span="12" v-if="isAdmin">
							<el-form-item label="运营商:" prop="distributorId">
								<el-select v-model="form.distributorId" placeholder="请选择运营商" clearable style="width: 100%;">
									<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
										:value="item.key">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="版本号:" prop="version">
								<el-input v-model.trim="form.version" placeholder="请输入版本号，如：1.0.0"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="是否开启:" prop="enabled">
								<el-radio-group v-model="form.enabled">
									<el-radio :label="1">开启</el-radio>
									<el-radio :label="0">关闭</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="免责声明内容:" prop="content">
						<div class="editor-wrapper">
							<quill-editor ref="myQuillEditor" v-model="form.content" :options="editorOption"
								@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
								@change="onEditorChange($event)">
							</quill-editor>
						</div>
					</el-form-item>
					<el-form-item label="备注:">
						<el-input type="textarea" v-model="form.remark" :rows="2" placeholder="请输入备注"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="submitForm">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

export default {
	components: {
		quillEditor
	},
	data() {
		return {
			isAdmin: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				distributorId: '',
				title: '',
				enabled: null
			},
			dataList: [],
			total: 0,
			distributorOptions: [],
			dialogVisible: false,
			dialogTitle: '',
			form: {
				id: '',
				title: '',
				distributorId: '',
				distributorName: '',
				content: '',
				enabled: 1,
				version: '',
				remark: ''
			},
			editorOption: {
				placeholder: '请输入免责声明内容...',
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						[{ 'indent': '-1' }, { 'indent': '+1' }],
						[{ 'align': [] }],
						['clean']
					]
				}
			},
			rules: {
				title: [
					{ required: true, message: '请输入标题', trigger: 'blur' }
				],
				distributorId: [
					{ required: true, message: '请选择运营商', trigger: 'change' }
				],
				content: [
					{ required: true, message: '请输入免责声明内容', trigger: 'blur' }
				]
			}
		}
	},
	created() {
		this.checkIsAdmin()
		if (this.isAdmin) {
			this.getDistributorOptions()
		}
		this.getList()
	},
	methods: {
		checkIsAdmin() {
			const isAdmin = window.sessionStorage.getItem('isAdmin')
			this.isAdmin = isAdmin === 'true' || isAdmin === true
		},
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = []
				if (res.data.code != 200) return
				let distributorInfoList = res.data.data
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name })
				}
			})
		},
		getList() {
			this.$http.post('/disclaimer/getDisclaimerPageInfo', this.queryParams).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg)
				this.dataList = res.data.data.list
				this.total = res.data.data.total
			})
		},
		handleQuery() {
			this.queryParams.pageNum = 1
			this.getList()
		},
		handleSizeChange(val) {
			this.queryParams.pageSize = val
			this.getList()
		},
		handleCurrentChange(val) {
			this.queryParams.pageNum = val
			this.getList()
		},
		handleAdd() {
			this.resetForm()
			this.dialogTitle = '添加免责声明'
			this.dialogVisible = true
		},
		handleEdit(row) {
			this.resetForm()
			this.dialogTitle = '编辑免责声明'
			this.$http.get(`/disclaimer/getDisclaimerById/${row.id}`).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg)
				this.form = {
					id: res.data.data.id,
					title: res.data.data.title,
					distributorId: res.data.data.distributorId,
					distributorName: res.data.data.distributorName,
					content: res.data.data.content || '',
					enabled: res.data.data.enabled,
					version: res.data.data.version,
					remark: res.data.data.remark || ''
				}
				this.dialogVisible = true
			})
		},
		handleDelete(row) {
			this.$confirm(`确认删除免责声明"${row.title}"吗？`, {
				title: "提示",
				type: 'warning',
			}).then(() => {
				this.$http.get(`/disclaimer/deleteDisclaimerById/${row.id}`).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg)
					this.getList()
					this.$message.success('删除成功')
				})
			}).catch(() => {})
		},
		handleStatusChange(row) {
			const params = {
				id: row.id,
				enabled: row.enabled
			}
			this.$http.post('/disclaimer/updateDisclaimerEnabled', params).then((res) => {
				if (res.data.code != 200) {
					row.enabled = row.enabled === 1 ? 0 : 1
					return this.$message.error(res.data.msg)
				}
				this.$message.success(res.data.msg)
			}).catch(() => {
				row.enabled = row.enabled === 1 ? 0 : 1
			})
		},
		resetForm() {
			this.form = {
				id: '',
				title: '',
				distributorId: '',
				distributorName: '',
				content: '',
				enabled: 1,
				version: '',
				remark: ''
			}
			if (this.$refs.formRef) {
				this.$refs.formRef.resetFields()
			}
		},
		onEditorBlur(editor) {
			// 编辑器失去焦点
		},
		onEditorFocus(editor) {
			// 编辑器获得焦点
		},
		onEditorChange({ editor, html, text }) {
			// 编辑器内容改变
			this.form.content = html
		},
		submitForm() {
			this.$refs.formRef.validate((valid) => {
				if (valid) {
					if (this.isAdmin && !this.form.distributorId) {
						return this.$message.warning('请选择运营商')
					}
					if (!this.form.content || this.form.content.trim() === '<p><br></p>') {
						return this.$message.warning('请输入免责声明内容')
					}
					if (this.form.distributorId) {
						const distributor = this.distributorOptions.find(d => d.key === this.form.distributorId)
						this.form.distributorName = distributor ? distributor.value : ''
					} else {
						this.form.distributorName = ''
					}
					const url = this.form.id ? '/disclaimer/updateDisclaimerById' : '/disclaimer/addDisclaimer'
					this.$http.post(url, this.form).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg)
						this.$message.success(res.data.msg)
						this.dialogVisible = false
						this.getList()
					})
				}
			})
		}
	}
}
</script>

<style scoped>
.disclaimer-container {
	height: 100%;
	display: flex;
	flex-direction: column;
}

.box-card {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
}

.search-area {
	position: sticky;
	top: 0;
	z-index: 10;
	background-color: #fff;
	padding: 15px 0;
	border-bottom: 1px solid #EBEEF5;
}

.table-container {
	flex: 1;
	overflow-y: auto;
	padding: 15px 0;
}

.pagination-container {
	padding: 15px 0;
	text-align: center;
	border-top: 1px solid #EBEEF5;
	background-color: #fff;
	position: sticky;
	bottom: 0;
	z-index: 10;
}

.editor-wrapper {
	width: 100%;
}

.editor-wrapper >>> .ql-container {
	min-height: 300px;
}

.editor-wrapper >>> .ql-editor {
	min-height: 300px;
}
</style>
